import React from 'react';
import { graphql } from 'gatsby';
import PostItem from '../components/PostItem';
import TitlePage from '../components/TitlePage';
import SEO from '../components/seo';
import useTranslations from '../components/useTranslations';
import Pagination from '../components/Pagination';
import Container from '../components/Container'
import Helmet from 'react-helmet';

import * as S from './post-list.styled';

const Blog = (props) => {
  const postList = props.data.allMarkdownRemark.edges;

  const locale = props.pageContext.locale; 

  const { news } = useTranslations(locale);

  // If all posts have 'noindex: true' then this overview wil also have noindex
  const noIndex = postList.find(x => x.node.frontmatter.noIndex !== true) ? false : true;


  // Logic for Pagination Component
  const { currentPage, numPages } = props.pageContext;
  const isFirst = currentPage === 1;
  const isLast = currentPage === numPages;
  const prevPage =
    currentPage - 1 === 1 ? '/blog' : `/blog/page/${currentPage - 1}`;
  const nextPage = `/blog/page/${currentPage + 1}`;

  return (
    <Container>
      <SEO title={news} lang={locale} />

      { noIndex &&
      <Helmet>
         <meta name="robots" content="noindex,nofollow"/>
      </Helmet>
      }

      <TitlePage text={news} />
      <S.ListWrapper>
        {postList.map(
          ({
            node: {
              frontmatter: {
                date,
                description,
                title,
                image,
              },
              fields: { slug },
            },
          }) => (
            <PostItem
              lang={locale}
              slug={`/blog/${slug}`}
              date={date}
              title={title}
              description={description}
              image={image}
              key={slug}
            />
          ),
        )}
      </S.ListWrapper>

      <Pagination
        lang={locale}
        isFirst={isFirst}
        isLast={isLast}
        currentPage={currentPage}
        numPages={numPages}
        prevPage={prevPage}
        nextPage={nextPage}
      />
    </Container>
  );
};

export const query = graphql`
  query PostsList($locale: String!, $dateFormat: String!, $skip: Int!, $limit: Int!) {
    allMarkdownRemark(
      sort: {fields: frontmatter___date, order: DESC}, 
      filter: { 
        fields: { locale: { eq: $locale } } 
        fileAbsolutePath: {regex: "/(blog)\/.*\\\\.md$/"}
      }
      limit: $limit
      skip: $skip
    ){
      edges {
        node {
          frontmatter {
            title
            description
            image
            date(formatString: $dateFormat, locale:$locale)
            noIndex
          }
          fields {
            locale
            slug
          }
        }
      }
    }
  }
`;

export default Blog;
